import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { GoogleAuthProvider, getAuth, signInWithPopup, createUserWithEmailAndPassword, signInWithEmailAndPassword, ErrorFn } from 'firebase/auth'
import { getFirestore, query, getDocs, collection, writeBatch, where, addDoc, getDoc, updateDoc, deleteDoc, doc } from 'firebase/firestore'
// import dotenv from 'dotenv';
// dotenv.config()
const config = {
    // apiKey: "AIzaSyBmE8EOkJFa8x8RHsl_BWSlRD0hKa3P50Y",
    // authDomain: process.env.FIREBASE_AUTH_DOMAIN,
    // projectId: process.env.FIREBASE_PROJECT_ID,
    // storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
    // messagingSenderId: process.env.FIREBASE_MESSAGE_SENDER_ID,
    // appId: process.env.FIREBASE_APP_ID,
    // measurementId: process.env.FIREBASE_MEASUREMENT_ID,
    apiKey: "AIzaSyBmE8EOkJFa8x8RHsl_BWSlRD0hKa3P50Y",
    authDomain: "completereact-982e5.firebaseapp.com",
    projectId: "completereact-982e5",
    storageBucket: "completereact-982e5.appspot.com",
    messagingSenderId: "448292088370",
    appId: "1:448292088370:web:b86716c5a2661f05bb2a2b",
    measurementId: "G-WCKBFL7N0N"
};

// Initialize Firebase
const app = initializeApp(config);

export const auth = getAuth(app)
export const db = getFirestore(app);


const googleProvider = new GoogleAuthProvider();
export const signInWithGoogle = async() => {
    try {
        const res = await signInWithPopup(auth, googleProvider)
        const user = res.user
        const queryy = query(collection(db, 'users'), where('uid', '==', user.uid))
        const docs = await getDocs(queryy)
        if (docs.docs.length === 0) {
            await addDoc(collection(db, 'users'), {
                uid: user.uid,
                name: user.displayName,
                email: user.email,
                avatar: user.photoURL,
                createdAt: new Date().toISOString()
            })
        }
        // console.log(docs.docs)
    } catch (error) {
        console.log(error)
    }
}

export const registerWithEmailAndPassword = async(name, email, password) => {
    try {
        const res = await createUserWithEmailAndPassword(auth, email, password)
        const user = res.user
        await addDoc(collection(db, 'users'), {
            uid: user.uid,
            name,
            email,
            password,
            avatar: 'https://www.sibberhuuske.nl/wp-content/uploads/2016/10/default-avatar.png',
            createdAt: new Date().toISOString()
        })
    } catch (error) {
        return error.code
            // console.log(error.code)
    }
}

export const logInWithEmailAndPassword = async(email, password) => {
    try {
        await signInWithEmailAndPassword(auth, email, password)
    } catch (error) {
        return error.code
    }
}

// Store data to firestore
export const addCollectionAndDocuments = async(collectionKey, objectsToAdd) => {
    const collectionRef = collection(db, collectionKey)
    const batch = writeBatch(db)

    objectsToAdd.forEach(object => {
        const docRef = doc(collectionRef, object.title.toLowerCase())
        batch.set(docRef, object)
    })

    await batch.commit()
    console.log('done')
}

export const getCategoriesAndDocuments = async() => {
    const collectionRef = collection(db, 'categories');
    const q = query(collectionRef)

    // fake error
    // await Promise.reject(new Error('Testing error').message)
    const querySnapshot = await getDocs(q)
    return querySnapshot.docs.map(docSnapshot => docSnapshot.data())
}

export const getEmailAndPassword = async() => {
    const collectionRef = collection(db, 'users');
    const q = query(collectionRef)
    const querySnapshot = await getDocs(q)
    return querySnapshot.docs.map(docSnapshot => docSnapshot.data())
}